import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import {
  classifierGeneralItemField,
  classifierGeneralItemLangField,
  classifierConsumptionUsageProperties,
} from '../../constants/classifier';
import classificatorTypes from '../../constants/classificators';

export default createValidation([
  {
    name: classifierGeneralItemField.CODE,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: `${classifierGeneralItemField.LANG}.${
      classifierGeneralItemLangField.EN
    }`,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: `${classifierGeneralItemField.LANG}.${
      classifierGeneralItemLangField.ET
    }`,
    validators: (field) => validatorRequired()(field),
  },
  {
    // Only required for CONSUMPTION_TYPE classifier
    name: `${classifierGeneralItemField.PROPERTIES}.${
      classifierConsumptionUsageProperties.START_DAY
    }`,
    validators: (field, form, props) =>
      props.classifierCode === classificatorTypes.consumptionUsage
        ? validatorRequired()(field)
        : undefined,
  },
  {
    // Only required for CONSUMPTION_TYPE classifier
    name: `${classifierGeneralItemField.PROPERTIES}.${
      classifierConsumptionUsageProperties.END_DAY
    }`,
    validators: (field, form, props) =>
      props.classifierCode === classificatorTypes.consumptionUsage
        ? validatorRequired()(field)
        : undefined,
  },
]);
